import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

const styles = makeStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '0.5rem',
    padding: '0 1rem',
  },

  buttonMenu: {
    color: Colors.white,
  },

  itemsContainer: {
    position: 'absolute',
    left: 0,
    top: 64,
    width: '100%',
    height: 'calc(100vh - 64px)',
    backgroundColor: Colors.transparentFormColor,
  },

  itemsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    backgroundColor: Colors.white,
    padding: '1rem',
    boxShadow: '-1px 2px 7px -3px #000000',
  },
}))

export default styles
